import React, { useContext, useEffect } from 'react'
import { GlobalContext } from '../../state'
import useGetRights from '../../hooks/useGetRights'
import { useLocation, useNavigate } from 'react-router-dom'
import { TiChevronRight } from 'react-icons/ti'
import Burger from '../Navigation/Burger'
import SidebarNav from '../Navigation/SidebarNav'
import { Outlet } from 'react-router-dom'
import {createTheme} from "@mui/material";
import LogoutButton from '../Authentication/LogoutButton'
import PriceTicker from "../Widget/PriceTicker";
import ImpersonationBanner from './ImpersonationBanner';

// Dark theme
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#161a1e',
      paper: '#6a7680',
    },
    text: {
      primary: '#e1eeff',
      secondary: '#b3b3b3',
    },
  },
});

const Layout = React.forwardRef(
  ({ toggleMenuActive }, ref) => {
    // Global state
    const { globalState, setGlobalState } = useContext(GlobalContext);
    const location = useLocation()
    const navigate = useNavigate()
    const getRights = useGetRights()

    const menuActiveClass = (isActive, currentClasses) => {
      return isActive ? `${currentClasses} is-active` : `${currentClasses}`
    }

    const locationPathname2Array = (pathname) =>
      pathname.split('/').filter((el) => el)

    useEffect(() => {
      if (!globalState.activeMenuItem) {
        // Pages that are not in the sidebar (/links, /help, /bot-setup) have
        // no entry to highlight. Only a match is written: setting a falsy
        // value would re-render and run this effect again, endlessly.
        const firstSegment = `/${locationPathname2Array(location.pathname)[0] ?? ''}`
        const match = globalState.sidebarNavItems.find(
          (item) => item.path === firstSegment
        )
        if (match) {
          setGlobalState((prevState) => ({
            ...prevState,
            activeMenuItem: match.name,
          }))
        }
      }
    })

    return (
      <div ref={ref} className={`container ${globalState.isMenuActive ? 'sidebar-open' : ''}`}>
        <header  style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 0",
          width: "100%",
        }}
        >
          <div className="flex-container">
            <Burger
              onClick={toggleMenuActive}
              className={menuActiveClass(
                globalState.isMenuActive,
                'hamburger hamburger--squeeze'
              )}
            />
          </div>
          <div style={{
            display: "flex",
            gap: "16px",
            alignItems: "center"
          }}>
            <PriceTicker symbol="BTC/USDC" exchangeId="BybitSpot" />
            {/* Second ticker gives way on narrow screens (Layout.css) */}
            <div className="header-ticker-optional">
              <PriceTicker symbol="ETH/USDC" exchangeId="BybitSpot" />
            </div>
          </div>
          {/* The logout button is absolutely positioned; this keeps its
              width free so the tickers never slide under it (Layout.css) */}
          <div className="header-logout">
            <LogoutButton />
          </div>
        </header>
        <nav>
          <div className="breadcrumb-container">
            {locationPathname2Array(location.pathname).map((item, idx, arr) => {
              if (idx < arr.length - 1)
                return (
                  <div key={idx}>
                    <button
                      onClick={() => navigate(`/${item}`)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'inherit',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        padding: '0',
                        margin: '0',
                        fontSize: 'inherit',
                        fontFamily: 'inherit',
                        lineHeight: 'inherit',
                        fontWeight: 'inherit'
                      }}
                    >
                      {item.charAt(0).toUpperCase() + item.slice(1)}
                    </button>
                    <TiChevronRight />
                  </div>
                )
              return <span key={idx}>{item}</span>
            })}
          </div>
        </nav>
        <main> <Outlet /></main>
        <ImpersonationBanner />
        <aside className={menuActiveClass(globalState.isMenuActive, '')}>
          <SidebarNav
            navItems={globalState.sidebarNavItems}
            activeItem={globalState.activeMenuItem}
            rights={getRights()}
            onClick={toggleMenuActive}
          />
        </aside>
      </div>
    )
  }
)

export default Layout
